import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {ConfirmPopup} from 'primereact/confirmpopup'
import React, {useRef} from 'react'
import {SystemRole} from '../../../Constants'
import TranslateUtils from '../../../i18n/TranslateUtils'
import GenericLogTable from '../../generic-log/GenericLogTable'
import StyledRelevantContactDatatable from '../next-of-kin/RelevantContactDatatable'
import {usePatientContext} from './StyleDetailInformationWrapper'
import StyledAdditionalInformationSection from './StyledAdditionalInformationSection'
import StyledBasicDetailInformationSection from './StyledBasicDetailInformationSection'
import StyledContactInformationSection from './StyledContactInformationSection'
import StyledGeneralPractitionerInformationSection from './StyledGeneralPractitionerInformationSection'

const StyledDetailInformationTabView = () => {
    useSignals()
    //#region Context
    const {currentViewedUser} = usePatientContext()
    //#endregion

    //#region Translate
    const {translateCommons, translateDatatable} = TranslateUtils()
    //#endregion

    //#region State
    //#endregion

    //#region Ref
    const genericRef = useRef(null)
    //#endregion

    return (
        <div className="w-full">
            <div className="w-full">
                {currentViewedUser?.systemRole &&
                    currentViewedUser?.systemRole === SystemRole.USER && (
                        <React.Fragment>
                            <ul className="m-0 p-0">
                                <li className="flex mb-1 border-round justify-content-center align-items-center py-3 px-2 flex-wrap bg-teal-50 ">
                                    <h5
                                        className={`pl-2 text-darkcyan font-bold w-full m-0 py-2 text-center  md:text-left`}>
                                        <span className="mr-3">
                                            <i className="pi pi-user font-bold text-xl"></i>
                                        </span>
                                        {translateCommons(
                                            "Patient's Information Audit Log",
                                        )}
                                    </h5>
                                </li>

                                <li className="flex align-items-center py-3 flex-wrap col-12">
                                    <div
                                        className={`col-12 m-0 p-0 flex gap-2 flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                                        <i className="underline m-0  text-700">
                                            {translateCommons(
                                                "The audit log shows various changes in patient's account since the account was created. It saves a record of these changes indefinitely, and you can view the entire change history.",
                                            )}
                                        </i>
                                        <div>
                                            <Button
                                                className="p-button-text audit-button gap-1 w-13rem px-3 "
                                                icon="pi pi-download"
                                                label={translateCommons(
                                                    'Show Audit Log',
                                                )}
                                                onClick={() =>
                                                    !!currentViewedUser?.id &&
                                                    genericRef.current.showForm(
                                                        {
                                                            refId: currentViewedUser?.id,
                                                            type: 'userLog',
                                                        },
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </React.Fragment>
                    )}
            </div>
            <StyledBasicDetailInformationSection />
            <StyledAdditionalInformationSection />
            <StyledContactInformationSection />
            <StyledGeneralPractitionerInformationSection />

            <hr />
            <li className="flex border-round justify-content-center align-items-center py-3 px-2 flex-wrap bg-teal-50 mb-3">
                <h5
                    className={`pl-2 text-darkcyan font-bold w-full m-0 py-2 text-center  md:text-left`}>
                    <span className="mr-3">
                        <i className="pi pi-book font-bold text-xl"></i>
                    </span>
                    {translateCommons('Relevant Contact')}
                </h5>
            </li>
            <StyledRelevantContactDatatable />

            <ConfirmPopup />
            <GenericLogTable ref={genericRef} />
        </div>
    )
}

export default StyledDetailInformationTabView
